function detectApiPrefix() {
    const IS_TESTBENCH = location.href.includes("testbench");
    if (IS_TESTBENCH) {
        return "/api";
    }
    return "/api/vclwsaa";
}
export function apiUrl(path) {
    if (!path.startsWith("/"))
        path = "/" + path;
    const prefix = detectApiPrefix();
    return prefix + path;
}
